import { useNavigate } from "react-router-dom";
import { Hammer, Calculator } from "lucide-react";

const SellerToolsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center px-6 py-12">
      <div className="text-center mb-10">
        <h1 className="text-2xl font-bold text-foreground mb-2">Tools</h1>
        <p className="text-muted-foreground">Select a tool to get started</p>
      </div>

      <div className="w-full max-w-sm space-y-4">
        <button
          onClick={() => navigate("/seller/tools/repair-estimator")}
          className="w-full p-6 rounded-xl border-2 border-godyspo-gold/30 bg-godyspo-gold/5 hover:bg-godyspo-gold/10 hover:border-godyspo-gold/50 transition-all duration-200 text-left group"
        >
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-godyspo-gold/20 flex items-center justify-center group-hover:bg-godyspo-gold/30 transition-colors">
              <Hammer className="w-7 h-7 text-godyspo-gold" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-foreground mb-1">Repair Estimator</h2>
              <p className="text-sm text-muted-foreground">Calculate rehab costs</p>
            </div>
          </div>
        </button>

        <button
          onClick={() => navigate("/seller/tools/profit-calculator")}
          className="w-full p-6 rounded-xl border-2 border-godyspo-blue/30 bg-godyspo-blue/5 hover:bg-godyspo-blue/10 hover:border-godyspo-blue/50 transition-all duration-200 text-left group"
        >
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-godyspo-blue/20 flex items-center justify-center group-hover:bg-godyspo-blue/30 transition-colors">
              <Calculator className="w-7 h-7 text-godyspo-blue" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-foreground mb-1">Profit Calculator</h2>
              <p className="text-sm text-muted-foreground">Analyze deal profitability</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default SellerToolsPage;
